import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { TransitionGroup, Transition, computed, markRaw, reactive } from "vue";
import { TransitionSlideDirection } from "./transition-slide-direction";


export default /*@__PURE__*/_defineComponent({
  __name: 'transition-slide',
  props: {
    direction: { default: "rtl" },
    isGroup: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const component = computed(() => (props.isGroup ? markRaw(TransitionGroup) : markRaw(Transition)));

const styles = reactive({
    overflow: "visible",
});

const setHidden = (value: boolean) => {
    styles.overflow = value ? "hidden" : "visible";
};

const name = computed(() => "slide--" + props.direction);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "transition-slide",
    style: _normalizeStyle(styles)
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
      name: name.value,
      onEnter: _cache[0] || (_cache[0] = ($event: any) => (setHidden(true))),
      onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (setHidden(false)))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 40, ["name"]))
  ], 4))
}
}

})